module.exports = __webpack_public_path__ + "media/images/icons/icons_small/42_marriageBed-3bf236a9454e31b4e886ff7276924d3f.png";